export default "__VITE_ASSET__jF3KHuPm__"